/**
 * Planning and shopping domain constants (PLAN.md §4, §7, §8; ADR 0004). Shared by the schema,
 * the sync contract and the client.
 */

/** The slots every household starts with, in order (`meal_slot` seed). */
export const DEFAULT_MEAL_SLOTS = [
  { key: 'breakfast', defaultTime: '08:00' },
  { key: 'lunch', defaultTime: '12:30' },
  { key: 'dinner', defaultTime: '18:30' },
  { key: 'snack', defaultTime: '15:30' },
] as const;
export type DefaultSlotKey = (typeof DEFAULT_MEAL_SLOTS)[number]['key'];

export const isDefaultSlotKey = (key: string): key is DefaultSlotKey =>
  DEFAULT_MEAL_SLOTS.some((s) => s.key === key);

/** A checked shopping item: bought, or already at home ("have it", swipe). */
export const SHOPPING_CHECK_STATES = ['checked', 'have_it'] as const;
export type ShoppingCheckState = (typeof SHOPPING_CHECK_STATES)[number];

/**
 * How the default shopping range ends: after a number of days, or the day before the next
 * shopping weekday.
 */
export const SHOPPING_RANGE_MODES = ['days', 'until_shopping_day'] as const;
export type ShoppingRangeMode = (typeof SHOPPING_RANGE_MODES)[number];

/** ISO weekday: 1 = Monday … 7 = Sunday. */
export type IsoWeekday = 1 | 2 | 3 | 4 | 5 | 6 | 7;

/** Defaults of `shopping_prefs` (also what a client assumes before the row has synced). */
export const DEFAULT_SHOPPING_PREFS = {
  rangeMode: 'until_shopping_day' as ShoppingRangeMode,
  rangeDays: 7,
  shoppingWeekday: 6 as IsoWeekday,
};
